/**
 * Vuex Module for GHL Polling State Management
 * Manages global state for GHL polling progress
 */

const state = {
  isPolling: false,
  progress: 0,
  statusMessage: 'Initializing request...',
  elapsedTime: 0,
  pollCount: 0,
  maxTimeout: 300000, // 5 minutes
  requestId: null,
};

const getters = {
  isPolling: (state) => state.isPolling,
  progress: (state) => state.progress,
  statusMessage: (state) => state.statusMessage,
  elapsedTime: (state) => state.elapsedTime,
  pollCount: (state) => state.pollCount,
  maxTimeout: (state) => state.maxTimeout,
  requestId: (state) => state.requestId,
};

const mutations = {
  SET_POLLING(state, isPolling) {
    console.log('[Vuex Mutation] SET_POLLING:', isPolling);
    state.isPolling = isPolling;
    console.log('[Vuex State] isPolling after mutation:', state.isPolling);
  },

  SET_PROGRESS(state, progress) {
    state.progress = progress;
  },

  SET_STATUS_MESSAGE(state, message) {
    state.statusMessage = message;
  },

  SET_ELAPSED_TIME(state, time) {
    state.elapsedTime = time;
  },

  SET_POLL_COUNT(state, count) {
    state.pollCount = count;
  },

  SET_REQUEST_ID(state, id) {
    state.requestId = id;
  },

  RESET_STATE(state) {
    console.log('[Vuex Mutation] RESET_STATE');
    state.isPolling = false;
    state.progress = 0;
    state.statusMessage = 'Initializing request...';
    state.elapsedTime = 0;
    state.pollCount = 0;
    state.requestId = null;
  },

  UPDATE_PROGRESS(state, { progress, elapsedTime, pollCount }) {
    state.progress = progress;
    state.elapsedTime = elapsedTime;
    state.pollCount = pollCount;
  },
};

const actions = {
  startPolling({ commit }, requestId) {
    console.log('[Vuex Action] startPolling called with requestId:', requestId);
    commit('SET_POLLING', true);
    commit('SET_REQUEST_ID', requestId);
    commit('SET_PROGRESS', 0);
    commit('SET_STATUS_MESSAGE', 'Initializing GHL request...');
    console.log('[Vuex Action] startPolling completed');
  },

  updateProgress({ commit }, { progress, elapsedTime, pollCount }) {
    console.log('[Vuex Action] updateProgress:', { progress, elapsedTime, pollCount });
    commit('UPDATE_PROGRESS', { progress, elapsedTime, pollCount });

    // Update status message based on elapsed time
    let message = 'Processing your request...';
    if (elapsedTime >= 120000) {
      message = 'Taking longer than expected...';
    } else if (elapsedTime >= 60000) {
      message = 'Still processing, please wait...';
    } else if (elapsedTime >= 30000) {
      message = 'Generating magic link...';
    }
    commit('SET_STATUS_MESSAGE', message);
  },

  stopPolling({ commit }) {
    console.log('[Vuex Action] stopPolling called');
    commit('RESET_STATE');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
